document.addEventListener('DOMContentLoaded', function () {
    // Aplica a máscara de CEP
    document.querySelectorAll('.js-maskCEP').forEach(element => {
        VMasker(element).maskPattern('99999-999');
        element.setAttribute('maxlength', '9');
    });

    // Aplica a máscara de CPF
    document.querySelectorAll('.js-maskCPF').forEach(element => {
        VMasker(element).maskPattern('999.999.999-99');
        element.setAttribute('maxlength', '14');
    });

    // Aplica a máscara de CNPJ
    document.querySelectorAll('.js-maskCNPJ').forEach(element => {
        VMasker(element).maskPattern('99.999.999/9999-99');
        element.setAttribute('maxlength', '18');
    });

    // Aplica a máscara de CPF ou CNPJ
    document.querySelectorAll('.js-maskCPFCNPJ').forEach(element => {
        element.setAttribute('maxlength', '18');
        aplicarMascaraCPFCNPJ(element); // já aplica com o valor atual
        element.addEventListener('input', function () {
            aplicarMascaraCPFCNPJ(element);
        });
    });

    // Aplica a máscara de Telefone
    document.querySelectorAll('.js-maskFone').forEach(element => {
        element.setAttribute('maxlength', '15');
        aplicarMascaraFone(element); // já aplica com o valor atual
        element.addEventListener('input', function () {
            aplicarMascaraFone(element);
        });
    });

    // Máscara de dinheiro (Inputmask)
    document.querySelectorAll('.js-maskMoney').forEach(element => {
        Inputmask('decimal', {
            alias: 'numeric',
            groupSeparator: '',
            autoGroup: true,
            digits: 2,
            radixPoint: ',',
            digitsOptional: false,
            clearMaskOnLostFocus: false,
            allowMinus: true,
            rightAlign: true,
            placeholder: '0,00',
            defaultValue: '0,00',
            prefix: ''
        }).mask(element);
    });
});

function aplicarMascaraFone(element) {
    const value = element.value.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (value.length <= 10) {
        VMasker(element).maskPattern('(99)9999-99999');
    } else if (value.length >= 11) {
        VMasker(element).maskPattern('(99)99999-99999');
    }
}

function aplicarMascaraCPFCNPJ(element) {
    const value = element.value.replace(/\D/g, ''); // Remove caracteres não numéricos
    if (value.length <= 11) {
        VMasker(element).maskPattern('999.999.999-99');
    } else if (value.length > 11) {
        VMasker(element).maskPattern('99.999.999/9999-99');
    }
}

$(function () {
    // Para campos monetários
    $('.js-maskMoney').on('blur', function () {
        var $this = $(this);
        var valor = $this.val().replace(/\./g, '').replace(',', '.'); // converte para formato numérico
        if (!isNumeric(valor)) {
            $this.val('0,00');
        }
    });

    // Para campos numéricos simples
    $('.js-maskNumber').on('blur', function () {
        var $this = $(this);
        var valor = $this.val();
        if (!isNumeric(valor)) {
            $this.val('0');
        }
    });

    // Função auxiliar para verificar se é número válido
    function isNumeric(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    }
});

//format money (datatables)
function formatMoney(number) {
    return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
}

//format date (datatables)
function formatDate(value) {
    let date = new Date(value);
    const day = date.toLocaleString('pt-BR', { day: '2-digit' });
    const month = date.toLocaleString('pt-BR', { month: '2-digit' });
    const year = date.toLocaleString('pt-BR', { year: 'numeric' });
    return year + '-' + month + '-' + day;
}